import { TableV3RangeFilterOptions } from 'common/table/types/TableV3';
import {
  CandidateFilterValueType,
  SourcingFilterField
} from 'modules/candidate-profile/types/CandidateSearchFilter';

export const YEARS_RANGE_FILTER_SETTINGS: TableV3RangeFilterOptions = {
  kind: 'number',
  unit: 'years'
};

// Mirrors vectorisation-service `src/field_registry.py`. No vectorDbKey: the
// endpoint resolves these itself.
export const UNIVERSAL_FILTER_FIELDS: SourcingFilterField[] = [
  {
    field: 'skills',
    type: CandidateFilterValueType.TEXT_ARRAY,
    label: 'Skills'
  },
  { field: 'tags', type: CandidateFilterValueType.TEXT_ARRAY, label: 'Tags' },
  {
    field: 'qualifications',
    type: CandidateFilterValueType.TEXT_ARRAY,
    label: 'Qualifications'
  },
  {
    field: 'currentRole',
    type: CandidateFilterValueType.TEXT_ARRAY,
    label: 'Current role'
  },
  {
    // The current title; `currentRole` is the history the dropdown filters on.
    field: 'currentJobTitle',
    type: CandidateFilterValueType.TEXT,
    label: 'Current role'
  },
  {
    field: 'currentCompany',
    type: CandidateFilterValueType.TEXT,
    label: 'Current company'
  },
  { field: 'fullName', type: CandidateFilterValueType.TEXT, label: 'Name' },
  { field: 'email', type: CandidateFilterValueType.TEXT, label: 'Email' },
  { field: 'phone', type: CandidateFilterValueType.TEXT, label: 'Phone' },
  {
    field: 'atsCandidateId',
    type: CandidateFilterValueType.TEXT,
    label: 'ATS candidate ID'
  },
  {
    field: 'originalSource',
    type: CandidateFilterValueType.TEXT,
    label: 'Original source'
  },
  {
    field: 'locationName',
    type: CandidateFilterValueType.TEXT,
    label: 'Location'
  },
  {
    field: 'currentRoleStartDate',
    type: CandidateFilterValueType.DATE,
    label: 'Started current role'
  },
  {
    field: 'latestApplicationDate',
    type: CandidateFilterValueType.DATE,
    label: 'Last applied'
  },
  {
    field: 'timeInRole',
    type: CandidateFilterValueType.NUMBER,
    label: 'Time in role',
    range: YEARS_RANGE_FILTER_SETTINGS
  },
  {
    field: 'expectedSalary',
    type: CandidateFilterValueType.NUMBER,
    label: 'Expected salary'
  },
  {
    field: 'yearsOfExperience',
    type: CandidateFilterValueType.NUMBER,
    label: 'Years of experience',
    range: YEARS_RANGE_FILTER_SETTINGS
  },
  {
    field: 'location',
    type: CandidateFilterValueType.GEO,
    label: 'Location radius'
  },
  {
    field: 'candidateProfileLists',
    type: CandidateFilterValueType.TEXT_ARRAY,
    label: 'Talent lists'
  }
];
